export default require('./TabOverflow').default
